module.exports = __webpack_public_path__ + "img/chu@3x.4289bb1e.png";